let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bNv64")).then(() => parcelRequire('c7q37'));